import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {appStore} from "./global.state";
import './index.css';
import './css/tailwind.css';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

import RouterConfig from "./router";

import { defineCustomElements } from '@ionic/pwa-elements/loader';

// react-image-lightbox
import 'react-image-lightbox/style.css';

ReactDOM.render(
  // @ts-ignore
  <Provider store={appStore}>
    <RouterConfig />
  </Provider>,
  document.getElementById('root')
);

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
